// extracted by mini-css-extract-plugin
export var img = "expo-passe-module--img--Yf7aW";
export var ul = "expo-passe-module--ul--zENFN";